import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import logger from 'redux-logger';
import createRootReducer  from '../reducers';
import { routerMiddleware } from 'connected-react-router';
import {EndPoints} from '../constants/api-config';

export default function configureStore(initialState, browserHistory) {
    const store = createStore(
        createRootReducer(browserHistory),
        initialState,
        (EndPoints.environment !== 'production') ? applyMiddleware(thunk, logger, routerMiddleware(browserHistory))
        : applyMiddleware(thunk, routerMiddleware(browserHistory))
    );

    return store;
}